var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{class:("btn btn--" + _vm.size + " btn--" + _vm.skin),attrs:{"type":_vm.type},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.text)?_c('span',{staticClass:"btn__text"},[_vm._v(_vm._s(_vm.text))]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }